import styled from "styled-components";

const Container = styled.div`
  position: relative;
  width: 100%;

  h3 {
    line-height: 30px;
    color: #cc5248;
    background-color: #ededed;
    font-weight: bold;
  }

  label {
    margin-bottom: 5px;
    font-weight: bold;
  }

  .MuiOutlinedInput-root.filter {
    width: 100%;
    height: 90px;
  }

  .MuiOutlinedInput-root.filter .MuiOutlinedInput-input {
    position: absolute;
    top: 0;
  }

  .buttons-container {
    float: right;
  }

  .buttons-container .MuiButton-root {
    color: white;
    background-color: grey;
    width: 80px;
    margin-left: 20px;
  }

  .cta-button-group {
    display: inline-flex;
    flex-direction: row;
    justify-content: space-around;
    font-size: 12px;
    flex: 1;
  }

  /* Actions dropdown button – matches Apply button styling */
  .cta-button.actions-dropdown-button {
    height: 36px !important;
    padding: 8px 16px !important;
    border-radius: 8px !important;
    background-color: #01151D !important;
    color: #FFF !important;
    text-transform: none !important;
    font-family: 'Source Sans Pro', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    border: 1px solid #111827 !important;
    box-shadow: none !important;
  }

  .cta-button.actions-dropdown-button:hover:not(.Mui-disabled) {
    background-color: #1c3e4a !important;
    border-color: #1c3e4a !important;
    box-shadow: none !important;
  }

  .cta-button.actions-dropdown-button.Mui-disabled {
    background-color: rgba(1, 21, 29, 0.02) !important;
    color: #9ca3af !important;
    border: 1px solid rgba(206, 213, 216, 0.50) !important;
    border-radius: 8px !important;
    cursor: not-allowed !important;
    opacity: 0.6 !important;
  }

  .cta-button.actions-dropdown-button .MuiButton-endIcon {
    color: #FFF !important;
    margin-left: 4px;
  }

  .cta-button.actions-dropdown-button.Mui-disabled .MuiButton-endIcon {
    color: #9ca3af !important;
  }

  /* Filled variant - matches Apply button styling */
  .cta-button.actions-dropdown-button-filled {
    background-color: #01151D !important;
    color: #FFF !important;
    border: 1px solid #111827 !important;
    box-shadow: none !important;
  }

  .cta-button.actions-dropdown-button-filled:hover:not(.Mui-disabled) {
    background-color: #1c3e4a !important;
    color: #FFF !important;
    border-color: #1c3e4a !important;
    box-shadow: none !important;
  }

  .cta-button.actions-dropdown-button-filled.Mui-disabled {
    background-color: rgba(1, 21, 29, 0.02) !important;
    color: #9ca3af !important;
    border: 1px solid rgba(206, 213, 216, 0.50) !important;
    cursor: not-allowed !important;
    opacity: 0.6 !important;
  }

  .cta-button.actions-dropdown-button-filled .MuiButton-endIcon {
    color: #FFF !important;
  }

  .cta-button.actions-dropdown-button-filled.Mui-disabled .MuiButton-endIcon {
    color: #9ca3af !important;
  }

  .cta-button.actions-dropdown-button .MuiButton-endIcon svg {
    font-size: 20px;
  }

  .cta-instruction {
    display: inline-flex;
    color: #6B7280;
    font-size: 12px;
    margin-left: 12px;
    align-items: center;
  }
`;

const Button = styled.div`
  float: right;
  color: white;
  background-color: grey;
`;

export { Container, Button };
